import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../hooks/redux-hooks";
import { setSEOSettings } from "../../../store/slices/main";
import CoverImage from "../../common/image/CoverImage";

type IProps = {
  icon: string;
  name: string;
  publicUrl: string;
  spotifyUrl: string | null;
};

const PlaylistCard: FC<IProps> = ({ icon, name, publicUrl, spotifyUrl }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [disableClick, setDisableClick] = useState<boolean>(false);
  const [isHovered, setIsHovered] = useState(false);

  const navigateAndSetSEOSettings = (
    link: string,
    appTitle: string,
    appDescription: string,
    appImg: string
  ) => {
    if (!disableClick) {
      navigate(`${link}`);
      dispatch(
        setSEOSettings({
          appTitle,
          appDescription,
          appImg,
        })
      );
    }
  };

  const handleClick = () => {
    if (!disableClick) {
      setDisableClick(true);
      setTimeout(() => setDisableClick(false), 250);
      navigateAndSetSEOSettings(`/playlists/${publicUrl}`, name, name, icon);
    }
  };

  return (
    <div className="max-w-32 flex flex-col justify-start items-start pt-7 touch-pan-y">
      <div className="relative flex flex-col justify-center items-center select-none">
        <div
          onClick={() => {
            handleClick();
            navigateAndSetSEOSettings(
              `/playlists/${publicUrl}`,
              name,
              name,
              icon
            );
          }}
          className="max-w-[6rem] min-w-[6rem] h-[6rem] flex justify-start items-center overflow-hidden rounded-md shadow-lg mb-3 select-none cursor-pointer md:max-w-[11.3rem] md:min-w-[11.3rem] md:h-[11.3rem] relative"
          style={{ position: "relative" }}
        >
          <CoverImage
            className="w-full h-full object-cover pointer-events-none select-none"
            src={icon}
            alt={name}
            draggable={true}
            style={{
              filter: isHovered ? "brightness(80%)" : "brightness(100%)",
              transition: "filter 0.3s ease-in-out",
            }}
          />
        </div>

        <h5
          onClick={() => {
            handleClick();
            navigateAndSetSEOSettings(
              `/playlists/${publicUrl}`,
              name,
              name,
              icon
            );
          }}
          className="max-w-[7.6rem] mb-1 text-[0.72rem] font-semibold text-black cursor-pointer md:hover:underline md:whitespace-normal overflow-hidden text-ellipsis line-clamp-3 md:max-w-[10.5rem]"
        >
          {name}
        </h5>
      </div>
    </div>
  );
};

export default PlaylistCard;
